module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'windows-aio': _vm.isWindowsAio
    },
    style: (_vm.styleObject),
    attrs: {
      "id": "app"
    }
  }, [_c('index-head', [_c('router-view', {
    attrs: {
      "name": "head"
    }
  })], 1), _vm._v(" "), _c('content-page', [_c('router-view')], 1), _vm._v(" "), (_vm.$route.name !== 'index') ? _c('index-footer') : _vm._e(), _vm._v(" "), _c('zoom-img')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-37efe2ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-37efe2ea"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1065
// module chunks = 1